/* eslint-disable camelcase */
/* eslint-disable no-return-assign */
/* eslint-disable no-unused-vars, func-names */
const editLawyerController = (
  $scope,
  $rootScope,
  $modal,
  $http,
  api,
  logger,
  $log,
  $q,
  usSpinnerService
) => {
  $scope.startSpin = function(spinnerID) {
    if (!$scope.spinneractive) {
      usSpinnerService.spin(spinnerID)
      $scope.spinneractive = true
      return $scope.startcounter++
    }
  }

  $scope.stopSpin = function(spinnerID) {
    if ($scope.spinneractive) {
      usSpinnerService.stop(spinnerID)
      $scope.spinneractive = false
    }
  }

  function fetchAllConsultants() {
    // If already fetched all admins just return from here
    if (!_.isEmpty($scope.allConsultants)) return
    // If already fetched all admins just return from here
    return api.fetchAllConsultants().then(
      response => ($scope.allConsultants = response.data),
      error => $log.info('error', error)
    )
  }

  $scope.openModal = function(userID, lawyerID, event) {
    var data
    event.preventDefault()
    event.stopPropagation()
    $scope.showActionsSpinner = true
    $scope.startSpin('spinner-' + lawyerID)
    if ($scope.loggedInLawyer) {
      $scope.selectedLawyer = $scope.loggedInLawyer.lawyer
      $scope.selectedLawyer.user = $scope.loggedInLawyer.user
    } else {
      $scope.selectedLawyer = _.where($scope.currentPageItems, {
        lawyer_ID: lawyerID,
      })[0]
    }

    if (
      !$scope.showNonRegisteredUser &&
      $scope.selectedLawyer.lawyer_Status !== 'NewUser'
    ) {
      $scope.dataValues = {}
      // eslint-disable-next-line no-unused-expressions
      // $scope.selectedLawyer
      $scope.blockFirms = []
      $scope.dataValues = {}
      data = {
        searchKeywords: '',
        filter: {},
        orderBy: {},
        showExpiredJobs: false,
      }
      $q.all([
        $http
          .post(
            '/api/fetch-block-firms',
            {
              id: $scope.selectedLawyer.lawyer_ID,
            },
            {
              contentType: 'application/json',
            }
          )
          .then(
            function({data, status, headers, config}) {
              $scope.blockFirms = data
            },
            function({data, status, headers, config}) {
              $scope.changeStatus(status)
            }
          ),

        $http
          .post(
            '/api/fetch-lawyer-categories',
            {
              id: $scope.selectedLawyer.lawyer_ID,
            },
            {
              contentType: 'application/json',
            }
          )
          .then(
            function({data, status, headers, config}) {
              $scope.lawyerCategories = data
            },
            function({data, status, headers, config}) {
              $scope.changeStatus(status)
            }
          ),

        $http
          .post(
            '/api/fetch-lawyer-selectivity',
            {
              id: $scope.selectedLawyer.lawyer_ID,
            },
            {
              contentType: 'application/json',
            }
          )
          .then(
            function({data, status, headers, config}) {
              $scope.lawyerSelectivity = data
            },
            function({data, status, headers, config}) {
              $scope.changeStatus(status)
            }
          ),

        $http
          .post('/api/fetch-lawyer-preferences-flag', {
            userId: $scope.selectedLawyer.userUserID,
          })
          .then(
            function(data) {
              $scope.lawyerPreferencesFlag = data.showPreferencesWizard
            },
            function({error, status}) {
              $scope.changeStatus(status)
            }
          ),
      ]).then(async function() {
        await fetchAllConsultants()
        $scope.initializeModal()
      })
    }
  }

  $scope.resetData = function() {
    $scope.modalFirms.forEach(function(firm, index, array) {
      firm.isApproved = false
    })
    $scope.modalCategories.forEach(function(category, index, array) {
      category.isApproved = false
    })
  }

  $scope.tempDataValues = {
    categories: [],
    lawyer: {},
    blockFirms: [],
  }

  $scope.initializeModal = function() {
    let modalInstance
    $scope.dataValues.lawyer = angular.copy($scope.selectedLawyer)
    $scope.tempDataValues.lawyer = angular.copy($scope.selectedLawyer)
    $scope.tempDataValues.lawyerPreferencesFlag = $scope.lawyerPreferencesFlag
    $scope.modalFirms.forEach(function(firm, index, array) {
      $scope.blockFirms.forEach(function(block_firm, index, array) {
        if (
          firm.firm_ID === block_firm.firmFirmID &&
          block_firm.isApproved === true
        ) {
          firm.isApproved = true
        }
      })
    })
    $scope.tempDataValues.selectivity = []
    let temporarySelectivity = angular.copy($scope.refSelectivities)
    temporarySelectivity.forEach(selectivity => {
      $scope.lawyerSelectivity.forEach(lawyerSelectivity => {
        if (selectivity.selectivity_ID === lawyerSelectivity.selectivity_ID)
          selectivity.isSelected = true
      })
      $scope.tempDataValues.selectivity.push(selectivity)
    })
    $scope.dataValues.blockFirms = $scope.modalFirms
    $scope.tempDataValues.blockFirms = angular.copy($scope.modalFirms)
    $scope.lawyerCategories.forEach(function(lawyer_category, index, array) {
      $scope.modalCategories.forEach(function(category, index, array) {
        if (
          category.cat_ID === lawyer_category.refCategoryCatID &&
          lawyer_category.isApproved
        ) {
          category.isApproved = true
        }
      })
    })
    $scope.dataValues.categories = $scope.modalCategories
    $scope.tempDataValues.categories = angular.copy($scope.modalCategories)
    $scope.tempDataValues.lawyer.PQE_Date = $scope.tempDataValues.lawyer.PQE
    $scope.tempDataValues.allConsultants = $scope.allConsultants

    $scope.stopSpin('spinner-' + $scope.selectedLawyer.lawyer_ID)

    modalInstance = $modal.open({
      templateUrl: 'myModalContent.html',
      controller: 'EditCandidateCtrl',
      resolve: {
        data: function() {
          return $scope.tempDataValues
        },
      },
    })
    modalInstance.result.then(
      function(updatedData) {
        $scope.startSpin('spinner-' + $scope.selectedLawyer.lawyer_ID)

        if (updatedData.categories) {
          updatedData.categories.forEach(cat => {
            $scope.refEmployerTypes.forEach(empCat => {
              if (cat.cat_ID === empCat.value) {
                empCat.isSelected = cat.isApproved
                empCat.originalSelection = cat.isApproved
              }
            })
          })
        }

        updatedData.lawyer.PQE = updatedData.lawyer.PQE_Date
        $scope.selectedLawyer = updatedData.lawyer

        $http.post('/api/edit-lawyer', updatedData).then(
          function({data, status, headers, config}) {
            $scope.successCallBack({updatedData: updatedData, data: data})
          },
          function({data, status, headers, config}) {}
        )
      },
      function() {
        $scope.resetData()
        $scope.dataValues = ''
      }
    )
  }
}

export {editLawyerController}



// WEBPACK FOOTER //
// ./scripts/shared/directives/actions-popup/controller.js